import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useMutation from '../../modules/react/hooks/useMutation';
import Component from '../components/HostnameCertSettingsDomainDeleteModal';

const DELETE_DOMAIN = gql`
  mutation DeleteDomain($hostnameId: ID!) {
    domainDelete(hostnameId: $hostnameId) {
      success
      userErrors {
        ...HostnameCertSettingsDomainDeleteModalUserError
      }
    }
  }

  ${Component.fragments.userError}
`;

const propTypes = {
  hostnameId: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
  refetchHostnames: PropTypes.func.isRequired,
};

const defaultProps = {};

const SUCCESS_MESSAGE = 'Domain successfully deleted';

const HostnameCertSettingsDomainDeleteModal = ({
  hostnameId,
  onDismiss,
  refetchHostnames,
  ...rest
}) => {
  const [deleteDomain, { data, error, loading }] = useMutation(DELETE_DOMAIN);

  const onCancelDelete = () => {
    if (data?.domainDelete?.success) {
      refetchHostnames();
    }

    onDismiss();
  };

  const onConfirmDelete = () => deleteDomain({ variables: { hostnameId } });

  const submitErrors = data?.domainDelete?.userErrors || [];

  if (error) {
    submitErrors.push({ code: 0, message: 'Could not delete domain' });
  }

  return (
    <Component
      onCancelDelete={onCancelDelete}
      onConfirmDelete={onConfirmDelete}
      submitErrors={submitErrors}
      submitting={loading}
      successMessage={data?.domainDelete?.success ? SUCCESS_MESSAGE : null}
      {...rest}
    />
  );
};

HostnameCertSettingsDomainDeleteModal.propTypes = propTypes;
HostnameCertSettingsDomainDeleteModal.defaultProps = defaultProps;

export default HostnameCertSettingsDomainDeleteModal;
